module.exports = __webpack_public_path__ + "static/media/uerre.f8de2b52.svg";